'use client'

import * as React from 'react'
import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import { CheckIcon } from '@/components/icons/check-icon'
import clsx from 'clsx'

import * as styles from './FormCheckbox.css'

const Checkbox = React.forwardRef<
	React.ElementRef<typeof CheckboxPrimitive.Root>,
	React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
	<CheckboxPrimitive.Root ref={ref} className={clsx(styles.checkboxRoot, className)} {...props}>
		<CheckboxPrimitive.Indicator className={styles.indicator}>
			<CheckIcon className={styles.checkIcon} />
		</CheckboxPrimitive.Indicator>
	</CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
